import { render, staticRenderFns } from "./SurgInfo.vue?vue&type=template&id=b3925a1c"
import script from "./SurgInfo.vue?vue&type=script&lang=js"
export * from "./SurgInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports